import React, { Component } from 'reactn';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown
} from 'reactstrap';
import { Link } from 'react-router-dom';
import i18n from '../../views/Pages/Login/i18n';

class HeaderDropdown extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            userAvatar: this.global.user && this.global.user.avatarUrl 
                ? this.global.user.avatarUrl 
                : `${(window.config.consul.CORE_URL || (typeof CORE_URL !== 'undefined' ? CORE_URL : '' ))}/images/placeholder`
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const currentAvatar = this.global.user && this.global.user.avatarUrl 
            ? this.global.user.avatarUrl 
            : `${(window.config.consul.CORE_URL || (typeof CORE_URL !== 'undefined' ? CORE_URL : '' ))}/images/placeholder`;

        if (currentAvatar !== this.state.userAvatar) {
            this.setState({ userAvatar: currentAvatar });
        }
    }

    dropAccnt() {
        return (
            <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <img 
                        className={"dropdown-avatar-image"} 
                        src={this.state.userAvatar} 
                        alt={this.global.user ? this.global.user.username : ""}
                    />
                    <i className="icon ion-android-arrow-dropdown"></i>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem header tag="div" className="text-center">
                        <strong>{i18n.t('header.settings')}</strong>
                    </DropdownItem>
                    {(window.config.consul.CLIENT || (typeof CLIENT !== 'undefined' ? CLIENT : '' )) !== "metro" &&
                        <DropdownItem tag={Link} to={"/users/edituser/" + this.global.user.username}>
                            <i className="fa fa-user"></i>{i18n.t('header.profile')}
                        </DropdownItem>
                    }
                    <DropdownItem tag={Link} to="/changepassword">
                        <i className="fa fa-key"></i>{i18n.t('header.passwordChange')}
                    </DropdownItem>
                    <DropdownItem tag={Link} to="/logout">
                        <i className="fa fa-lock"></i>{i18n.t('header.logout')}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }

    render() {
        return this.dropAccnt();
    }
}

export default HeaderDropdown;